$(document).ready(() => {
  function getProductCardTemplate(product, analog) {
    let fallbackImage
    let mainImage
    let hoverImage

    if (analog) {
      fallbackImage = 'https://cdn.shopify.com/s/files/1/2488/5538/files/product-placeholder.png?v=1746444858';
      mainImage = product.imgs && product.imgs.img1 ? product.imgs.img1 : fallbackImage;
      hoverImage = product.imgs && product.imgs.img2 ? product.imgs.img2 : mainImage;
    } else {
      fallbackImage = 'https://cdn.shopify.com/s/files/1/2488/5538/files/product-placeholder.png?v=1746444858';
      mainImage = product.imgs && product.imgs[0] ? product.imgs[0] : fallbackImage;
      hoverImage = product.imgs && product.imgs[1] ? product.imgs[1] : mainImage;
    }

    return `
      <div class="m-search-item m:column">
        <div class="m-product-card m-product-card--style-3 m-product-card--view-list m-product-card--show-second-img m-gradient m-color-background-1" data-view="card" data-product-id="${product.id}">
          <div class="m-product-card__media">
          <div class="m-product-card__wishlist">
              <button class="m-tooltip m-wishlist-button m-button--icon" type="button" aria-label="Lisää toivelistaan" data-product-handle="${product.handle}" data-tippy-theme="m-color-background-1" data-tippy-content="Lisää toivelistaan" data-revert-text="Poista toivelistalta" data-tippy-role="tooltip-wishlist-${product.handle}">
                <span class="m-tooltip-icon m:block">
                  <svg class="m-svg-icon m-svg-icon--medium" viewBox="0 0 20 20" fill="none">
                    <path d="M10 16.875C10 16.875 1.875 12.5 1.875 7.34375C1.875 6.22487 2.31947 5.15181 3.11064 4.36064C3.90181 3.56947 4.97487 3.125 6.09375 3.125C7.85859 3.125 9.37031 4.08672 10 5.625C10.6297 4.08672 12.1414 3.125 13.9062 3.125C15.0251 3.125 16.0982 3.56947 16.8894 4.36064C17.6805 5.15181 18.125 6.22487 18.125 7.34375C18.125 12.5 10 16.875 10 16.875Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </span>
              </button>
            </div>
            <a class="m-product-card__link m:block m:w-full" href="/products/${product.handle}" aria-label="${product.title}">
              <responsive-image class="m-product-card__main-image m-image m-image-loaded" style="--aspect-ratio: 1/1;" intersecting="true">
                <img src="${mainImage}" alt="${product.title}" srcset="${mainImage}&width=165 165w, ${mainImage}&width=352 352w, ${mainImage}&width=832 832w" width="287" loading="lazy" class="m:w-full m:h-full" sizes="287px" height="287">
              </responsive-image>
              <responsive-image class="m-product-card__hover-image m-image m-image-loaded" style="--aspect-ratio: 1/1;" intersecting="true">
                <img src="${hoverImage}" alt="${product.title}" srcset="${hoverImage}&width=165 165w, ${hoverImage}&width=352 352w, ${hoverImage}&width=832 832w" width="287" loading="lazy" class="m:w-full m:h-full" sizes="287px" height="287">
              </responsive-image>
            </a>
            <div class="m-product-card__tags">
              ${product.tags ? product.tags.map(tag => `<span class="m-product-card__tag-name m-product-tag m-product-tag--${tag.type}">${tag.text}</span>`).join('') : ''}
            </div>
            <div class="m-product-card__action m:hidden md:m:flex">
              <button class="m-tooltip m-product-quickview-button m-spinner-button m-button--icon" type="button" aria-label="Katsaus" data-product-handle="${product.handle}" data-tippy-theme="m-color-background-1" data-tippy-content="Katsaus">
                <span class="m-spinner-icon">
                  <svg class="animate-spin m-svg-icon--medium" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                </span>
                <span class="m-tooltip-icon m:block">
                  <svg class="m-svg-icon m-svg-icon--medium" viewBox="0 0 20 20" fill="none">
                    <path d="M10 4.375C3.75 4.375 1.25 10 1.25 10C1.25 10 3.75 15.625 10 15.625C16.25 15.625 18.75 10 18.75 10C18.75 10 16.25 4.375 10 4.375Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M10 13.125C11.7259 13.125 13.125 11.7259 13.125 10C13.125 8.27411 11.7259 6.875 10 6.875C8.27411 6.875 6.875 8.27411 6.875 10C6.875 11.7259 8.27411 13.125 10 13.125Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </span>
              </button>
              <button class="m-tooltip m-wishlist-button m-button--icon" type="button" aria-label="Lisää toivelistaan" data-product-handle="${product.handle}" data-tippy-theme="m-color-background-1" data-tippy-content="Lisää toivelistaan" data-revert-text="Poista toivelistalta" data-tippy-role="tooltip-wishlist-${product.handle}">
                <span class="m-tooltip-icon m:block">
                  <svg class="m-svg-icon m-svg-icon--medium" viewBox="0 0 20 20" fill="none">
                    <path d="M10 16.875C10 16.875 1.875 12.5 1.875 7.34375C1.875 6.22487 2.31947 5.15181 3.11064 4.36064C3.90181 3.56947 4.97487 3.125 6.09375 3.125C7.85859 3.125 9.37031 4.08672 10 5.625C10.6297 4.08672 12.1414 3.125 13.9062 3.125C15.0251 3.125 16.0982 3.56947 16.8894 4.36064C17.6805 5.15181 18.125 6.22487 18.125 7.34375C18.125 12.5 10 16.875 10 16.875Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </span>
              </button>
            </div>
          </div>
          <div class="m-product-card__content m:text-left">
            <a class="m-product-card__hidden-link m:hidden" href="/products/${product.handle}" aria-label="${product.title}"></a>
            <div class="m-product-card__info" data-product-id="${product.id}" data-intercars="true">
              <div class="m-product-card__info-wrapper ">
              <h3 class="m-product-card__title h6">
                <a href="/products/${product.handle}" class="m-product-card__name">
                  ${product.title}
                </a>
              </h3>
              ${product.vendor ? `<div class="m-product-card__vendor m:text-sm m:text-color-subtext" style="font-size: 13px; color: #666; margin-bottom: 5px; margin-top: 0;">${product.vendor}</div>` : ''}
              <div class="m-product-card__price">
                <div class="m-price m:inline-flex m:items-center m:flex-wrap" data-sale-badge-type="percentage">
                  <div class="m-price__regular">
                    <span class="m:visually-hidden m:visually-hidden--inline">Normaalihinta</span>
                    <span class="m-price-item m-price-item--regular">
                      € ${product.price}
                    </span>
                  </div>
                </div>
              </div>
              <div class="m-product-card__description">
                ${product.description || ''}
              </div>
              <div class="m-product-card__action">
                <button class="m-tooltip m-product-quickview-button m-spinner-button m-button--icon" type="button" aria-label="Katsaus" data-product-handle="${product.handle}" data-tippy-theme="m-color-background-1" data-tippy-content="Katsaus">
                  <span class="m-spinner-icon">
                    <svg class="animate-spin m-svg-icon--medium" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  </span>
                  <span class="m-tooltip-icon m:block">
                    <svg class="m-svg-icon m-svg-icon--medium" viewBox="0 0 20 20" fill="none">
                      <path d="M10 4.375C3.75 4.375 1.25 10 1.25 10C1.25 10 3.75 15.625 10 15.625C16.25 15.625 18.75 10 18.75 10C18.75 10 16.25 4.375 10 4.375Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                      <path d="M10 13.125C11.7259 13.125 13.125 11.7259 13.125 10C13.125 8.27411 11.7259 6.875 10 6.875C8.27411 6.875 6.875 8.27411 6.875 10C6.875 11.7259 8.27411 13.125 10 13.125Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </span>
                </button>
                <button class="m-tooltip m-wishlist-button m-button--icon" type="button" aria-label="Lisää toivelistaan" data-product-handle="${product.handle}" data-tippy-theme="m-color-background-1" data-tippy-content="Lisää toivelistaan" data-revert-text="Poista toivelistalta" data-tippy-role="tooltip-wishlist-${product.handle}">
                  <span class="m-tooltip-icon m:block">
                    <svg class="m-svg-icon m-svg-icon--medium" viewBox="0 0 20 20" fill="none">
                      <path d="M10 16.875C10 16.875 1.875 12.5 1.875 7.34375C1.875 6.22487 2.31947 5.15181 3.11064 4.36064C3.90181 3.56947 4.97487 3.125 6.09375 3.125C7.85859 3.125 9.37031 4.08672 10 5.625C10.6297 4.08672 12.1414 3.125 13.9062 3.125C15.0251 3.125 16.0982 3.56947 16.8894 4.36064C17.6805 5.15181 18.125 6.22487 18.125 7.34375C18.125 12.5 10 16.875 10 16.875Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </span>
                </button>
              </div>
              </div>
            </div>
            <div class="m-product-card__quick-add m-product-card__quick-add-icon">
              <input hidden name="id" required value="${product.variantId || ''}" data-selected-variant="">
              <button class="m-product-form ${product.available === false ? "disabled" : ""} m:w-full m-product-quickview-button m-spinner-button m-button m-button--outline" data-product-url="/products/${product.handle}" data-product-id="${product.id}" data-product-handle="${product.handle}" aria-label="Valitse vaihtoehdot">
                <span class="m-spinner-icon">
                  <svg class="animate-spin m-svg-icon--medium" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                </span>
                <span class="m-add-to-cart--text">LISÄÄ OSTOSKORIIN</span>
                <svg class="m-svg-icon m-svg-icon--mobile" width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.4483 13.2135C5.72963 13.2135 5.9583 13.4422 5.9583 13.7235C5.9583 14.0048 5.72963 14.2328 5.4483 14.2328C5.16696 14.2328 4.93896 14.0048 4.93896 13.7235C4.93896 13.4422 5.16696 13.2135 5.4483 13.2135Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9497 13.2135C13.231 13.2135 13.4597 13.4422 13.4597 13.7235C13.4597 14.0048 13.231 14.2328 12.9497 14.2328C12.6684 14.2328 12.4397 14.0048 12.4397 13.7235C12.4397 13.4422 12.6684 13.2135 12.9497 13.2135Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.33325 2.16663L3.71992 2.40663L4.36192 10.0553C4.41392 10.6786 4.93459 11.1573 5.55992 11.1573H12.8346C13.4319 11.1573 13.9386 10.7186 14.0246 10.1266L14.6573 5.75463C14.7353 5.21529 14.3173 4.73263 13.7726 4.73263H3.94259" fill="white"></path>
                  <path d="M2.33325 2.16663L3.71992 2.40663L4.36192 10.0553C4.41392 10.6786 4.93459 11.1573 5.55992 11.1573H12.8346C13.4319 11.1573 13.9386 10.7186 14.0246 10.1266L14.6573 5.75463C14.7353 5.21529 14.3173 4.73263 13.7726 4.73263H3.94259" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M9.91699 7.19653H11.7657" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </button>
            </div>
          </div>
          <input hidden name="id" required value="${product.variantId || ''}" data-selected-variant="">
        </div>
      </div>
    `;
  }

  // --- Скелетон ---
  function getSkeletonLoaderTemplate() {
    return `
      <div class="m-search-item m:column m-skeleton-loader">
        <div class="m-product-card m-product-card--style-3 m-product-card--view-list m-product-card--show-second-img m-gradient m-color-background-1">
          <div class="m-product-card__media">
            <div class="m-product-card__link m:block m:w-full" style="background: #f0f0f0; height: 287px; animation: pulse 1.5s infinite;"></div>
          </div>
          <div class="m-product-card__content m:text-left">
            <div class="m-product-card__info">
              <div class="m-product-card__info-wrapper ">
              <div class="m-product-card__title h6" style="background: #f0f0f0; height: 20px; width: 80%; margin-bottom: 10px; animation: pulse 1.5s infinite;"></div>
              <div class="m-product-card__vendor m:text-sm m:text-color-subtext" style="background: #f0f0f0; height: 13px; width: 40%; margin-bottom: 5px; animation: pulse 1.5s infinite;"></div>
              <div class="m-product-card__price" style="background: #f0f0f0; height: 20px; width: 60%; margin-bottom: 10px; animation: pulse 1.5s infinite;"></div>
              <div class="m-product-card__description" style="background: #f0f0f0; height: 40px; width: 100%; margin-bottom: 10px; animation: pulse 1.5s infinite;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function showSkeletonLoaders(count = 8) {
    const productsContainer = $('.m-search-result');
    productsContainer.empty();
    for (let i = 0; i < count; i++) {
      productsContainer.append(getSkeletonLoaderTemplate());
    }
  }

  // Get query from URL
  function getQueryFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('q') || '';
  }

  // Search products
  function searchProducts() {
    const query = getQueryFromUrl();
    if (!query) return;

    showSkeletonLoaders();
    $('.m-load-more-wrapper').remove();

    fetch(`${window.apiConfig?.tecDocApiBase || 'https://tec-doc.gadget.app'}/search`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      },
      body: JSON.stringify({query: query})
    })
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.json();
        })
        .then(data => {
          // Удаляем только скелетоны
          $('.m-search-result').find('.m-skeleton-loader').remove();
          // Очищаем контейнер
          $('.m-search-result').empty();
          // Добавляем новые результаты
          let hasResults = false;
          if (data.searchResult && data.searchResult.length > 0) {
            hasResults = true;
            $(".m-breadcrumb--item-current").text(`${data.searchResult.length + data.analogSearchResult.length} ${$('.m-breadcrumb--item-current').text()}`)
            $(".m-search-template__title").text(`${data.searchResult.length + data.analogSearchResult.length} ${$('.m-search-template__title').text()}`)

            data.searchResult.forEach(product => {
              const productHtml = getProductCardTemplate(product, false);
              $('.m-search-result').append(productHtml);
            });
          }
          if (data.analogSearchResult && data.analogSearchResult.length > 0) {
            hasResults = true;
            data.analogSearchResult.forEach(product => {
              const productHtml = getProductCardTemplate(product.product, true);
              $('.m-search-result').append(productHtml);
            });
          }
          if (!hasResults) {
            $('.m-search-result').append('<p>Tuloksia ei löytynyt valituilla suodattimilla. Vaihda suodattimia ja yritä uudelleen, kiitos.</p>');
          }

          // Обновляем состояние кнопок вишлиста после рендеринга всех продуктов
          if (hasResults) {
            MinimogTheme.Wishlist.setWishlistButtonsState()
          }
        })
        .catch(error => {
          console.error('Error searching products:', error);
          $('.m-search-result').find('.m-skeleton-loader').remove();
          if (!$('.m-search-result').children().length) {
            $('.m-search-result').append('<p>Error loading products</p>');
          }
        });
  }

  // Run search when page loads
  searchProducts();
})